export default class AreaPress {
	constructor(node) {
		this.node = node;

		this.listingComunicatiStampa = node.querySelector('.listing-download .step-comunicati-stampa');
		this.listingImmagini = node.querySelector('.listing-download .step-immagini');

		this.filtriNode = node.querySelector('.area-download__filtri');
		this.filtroTipoNode = this.filtriNode.querySelector('#type-file');
		this.filtroFamigliaNode = this.filtriNode.querySelector('#type-famiglia');
		this.filtroDataNode = this.filtriNode.querySelector('#type-data');

		this.comunicatiStampaCache = {};

		this.addListeners();
	}

	addListeners() {
		let _this = this;

		// Filtro primo livello.
		this.filtroTipoNode.addEventListener('change', function() {
			let responseData = {};

			let submittedData = {
				data: {
					tipoFile: this.value
				}
			};

			_this.hideAllFilters();
			_this.hideAllListings();

			if (this.value === "comunicati-stampa") {
				if (Object.keys(_this.comunicatiStampaCache).length === 0) {
					$.ajax({
						type: "POST",
						url: "/WS/wsAreaPress.asmx/GetComunicatiStampa",
						cache: false,
						contentType: "application/json; charset=utf-8",
						data: JSON.stringify(submittedData),
						dataType: "json",
						success: function(data) {
							responseData = data;

							let comunicatiStampa = JSON.parse(responseData.d.HTML);
							_this.comunicatiStampaCache = comunicatiStampa;

							let dataOptions = [];
							for (let id in comunicatiStampa) {
								let comunicatoStampa = comunicatiStampa[id];
								let data = comunicatoStampa["data"];

								dataOptions[data] = { id: data, name: data };
							}
							_this.updateSelect(_this.filtroDataNode, dataOptions);
							_this.showFilter(_this.filtroDataNode);
						},
						error: function(data) {
							responseData = data;
						},
						complete: function() {
							// console.log(responseData);
						}
					});
				} else {
					_this.showFilter(_this.filtroDataNode);
				}
			} else if (this.value === "immagini") {
				$.ajax({
					type: "POST",
					url: "/WS/wsAreaPress.asmx/GetCategorieImmaginiPress",
					cache: false,
					contentType: "application/json; charset=utf-8",
					data: JSON.stringify(submittedData),
					dataType: "json",
					success: function(data) {
						responseData = data;

						let options = JSON.parse(responseData.d.HTML);
						_this.updateSelect(_this.filtroFamigliaNode, options);
						_this.showFilter(_this.filtroFamigliaNode);
					},
					error: function(data) {
						responseData = data;
					},
					complete: function() {
						// console.log(responseData);
					}
				});
			}
		});

		this.filtroDataNode.addEventListener('change', function() {
			if (this.value === "") {
				return;
			}

			_this.clearAllListings();

			let tplListingItem = _this.listingComunicatiStampa.querySelector('[data-tpl-download-file]').cloneNode(true);
			tplListingItem.removeAttribute('data-tpl-download-file');
			tplListingItem.removeAttribute('style');

			let selectedData = this.value;

			for (let id in _this.comunicatiStampaCache) {
				let comunicatoStampa = _this.comunicatiStampaCache[id];

				if (comunicatoStampa["data"] === selectedData) {
					let comunicatoStampaNode = tplListingItem.cloneNode(true);

					comunicatoStampaNode.querySelector('.filename').innerHTML = comunicatoStampa.title;
					comunicatoStampaNode.querySelector('.download a').setAttribute("href", comunicatoStampa.fileURL);

					_this.listingComunicatiStampa.querySelector(".file-list").appendChild(comunicatoStampaNode);
				}
			}

			_this.showListing(_this.listingComunicatiStampa);
		});

		this.filtroFamigliaNode.addEventListener('change', function() {
			if (this.value === "") {
				return;
			}

			let responseData = {};

			let submittedData = {
				data: {
					valoreFiltro: this.value
				}
			};

			_this.hideAllListings();
			_this.clearAllListings();

			$.ajax({
				type: "POST",
				url: "/WS/wsAreaPress.asmx/GetListaImmaginiPress",
				cache: false,
				contentType: "application/json; charset=utf-8",
				data: JSON.stringify(submittedData),
				dataType: "json",
				success: function(data) {
					responseData = data;

					let immagini = JSON.parse(responseData.d.HTML);
					_this.updateListingImmagini(immagini);
					_this.showListing(_this.listingImmagini);
				},
				error: function(data) {
					responseData = data;
				},
				complete: function() {
					// console.log(responseData);
				}
			});
		});
	}

	clearListingComunicatiStampa() {
		this.listingComunicatiStampa.querySelector('.file-list').innerHTML = "";
	}

	clearListingImmagini() {
		this.listingImmagini.querySelector('.file-list').innerHTML = "";
	}

	clearAllListings() {
		this.clearListingComunicatiStampa();
		this.clearListingImmagini();
	}

	updateListingImmagini(immagini) {
		let tplListingItem = this.listingImmagini.querySelector('[data-tpl-download-file]').cloneNode(true);
		tplListingItem.removeAttribute('data-tpl-download-file');
		tplListingItem.removeAttribute('style');

		for (let id in immagini) {
			let immagine = immagini[id];

			let immagineNode = tplListingItem.cloneNode(true);

			immagineNode.querySelector('a').setAttribute("href", immagine.fileURL);
			immagineNode.querySelector('img').setAttribute("src", immagine.fileURL);
			immagineNode.querySelector('.title').innerHTML = immagine.co_title;

			this.listingImmagini.querySelector(".file-list").appendChild(immagineNode);

			// Gestione click pulsante "Richiedi immagine hires"
			immagineNode.querySelector('[data-request-hires]').addEventListener('click', function(e) {
				e.preventDefault();

				$.fancybox.open({
					src: '#request-hires-form-wrapper',
					type: 'inline',
					opts: {
						afterShow: function(instance, current) {
							let formNode = document.querySelector('.fancybox-content form');

							$(formNode).validate({
								getDataToSend: function(form) {
									return {
										data: {
											coid: immagine.co_id,
											imid: immagine.im_id,
											note: formNode.querySelector('textarea[name="Note"]').value
										}
									};
								},
								callbackHandler: function(data, form) {
									formNode.querySelector('.response-text').innerHTML = data.d.HTML;
								}
							});
						}
					}
				});
			});
		}
	}

	showListing(listingNode) {
		listingNode.style.display = "block";
	}

	hideListing(listingNode) {
		listingNode.style.display = "none";
	}

	hideAllListings() {
		this.node.querySelectorAll('.listing-download .step').forEach(function(listingNode) {
			listingNode.style.display = "none";
		});
	}

	showFilter(filterNode) {
		filterNode.style.display = "block";
	}

	hideFilter(filterNode) {
		filterNode.style.display = "none";
	}

	hideAllFilters() {
		// Nasconde tutti i filtri (tranne il primo livello).
		this.filtriNode.querySelectorAll('select:not(#type-file)').forEach(function(filtroNode) {
			filtroNode.style.display = "none";
			filtroNode.querySelector('option:first-child').selected = 'selected';
		});
	}

	updateSelect(selectNode, options) {
		selectNode.options.length = 1;

		for (let id in options) {
			let option = document.createElement("option");

			option.value = options[id].id;
			option.text = options[id].name;

			selectNode.add(option);
		}
	}

	static init() {
		let areaPressNode = document.querySelector("[data-area-press]");

		if (areaPressNode) {
			return new AreaPress(areaPressNode);
		}
	}
}
